import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';
import { SampleLifecycleGroup } from './types';
import { TFunction } from 'i18next';

export function sampleLifecycleGroupTitle(
  group: SampleLifecycleGroup,
  t: TFunction,
) {
  switch (ensureEnumNumber(SampleLifecycleGroup, group)) {
    case SampleLifecycleGroup.UnhandledSamples:
      return t('sample.receivedInternally');
    case SampleLifecycleGroup.InInternalTransport:
      return t('sample.inTransport');
    case SampleLifecycleGroup.UnderwayFromSupplier:
      return t('sample.awaitingFromSupplier');
    case SampleLifecycleGroup.ReceivedFromSupplier: {
      return t('sample.receivedFromSupplier');
    }
    case SampleLifecycleGroup.InBrandTransport: {
      return t('sample.inTransportToBrand');
    }
    case SampleLifecycleGroup.ReceivedAtBrand: {
      return t('sample.receivedAtBrand');
    }
    case SampleLifecycleGroup.HandledSamples: {
      return t('sample.handledSamples');
    }
  }
}
